<template>
  <div class="room-modal">
    <carousel :images="carousel_images" />
    <p class="room-modal__title" v-if="carousel_images.length">{{ room.name.it }}</p>
    <div class="room-modal__wrap">
      <div class="room-modal__bed">
        <vb-icon class="room-modal__bed-icon mr-1" :name="'doublebed'" :color="'000'" :size="16" />
        <span
          class="room-modal__bed-text"
          v-html="format_beds(room.bed_options)"
        />
      </div>
      <div class="room-modal__cots">
        <span class="room-modal__cots-text">Culle e letti supplementari disponibili su richiesta</span>
        <vb-icon
          class="room-modal__cots-icon ml-1"
          :name="'info'"
          :color="sass('gray-500')"
          :size="13"
          v-b-popover.hover.top="'Per maggiori informazioni visita la sezione: Condizioni per i bambini e letti supplementari'"
        />
      </div>
    </div>
    <p class="room-modal__desc">{{ room.description.it }}</p>
    <room-info :room="room" />
    <div class="room-modal__facilities" :class="show_facilities && 'room-modal__facilities--open'">
      <p class="room-modal__facilities-title">Servizi</p>
      <ul class="room-modal__facilities-list">
        <li
          class="room-modal__facilities-list_item"
          v-for="(facility, facility_index) in room.facilities"
          :key="_uid + 'facility' + facility_index"
        >
          <vb-icon class="room-modal__facilities-list_icon" :name="get_room_facilities(facility).icon" :color="'f1ae04'" :size="14" />
          <span class="room-modal__facilities-list_text">{{ get_room_facilities(facility).label }}</span>
        </li>
      </ul>
    </div>
    <span
      class="room-modal__show"
      v-if="room.facilities.length > 15"
      v-html="!show_facilities ? 'vedi tutti' : 'chiudi'"
      @click="toggle_facilities()"
    />
  </div>
</template>

<script>
import Carousel from '@components/blocks/images/carousel.vue'
import RoomInfo from '@bookingv3/components/blocks/detail/room/room-info'
import { format_beds } from '@bookingv3/utilities'
import { room_carousel_images } from '@bookingv3/utilities/images'
import { get_room_facilities } from '@bookingv3/resources'

export default {
  name: 'room-modal',

  components: {
    'carousel': Carousel,
    'room-info': RoomInfo,
  },

  props: {
    room: Object
  },

  data() {
    return {
      show_facilities: false
    }
  },

  computed: {
    carousel_images() {
      return room_carousel_images(this.room)
    },
  },

  created() {
    this.format_beds = format_beds
    this.get_room_facilities = get_room_facilities
  },

  mounted() {
  },

  methods: {
    toggle_facilities() {
      this.show_facilities = !this.show_facilities
    },
  },
}
</script>

<style lang="scss" scoped>

  .room-modal {

    &__title {
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 0;
    }

    &__wrap {
      margin-bottom: 10px;
      flex-wrap: wrap;
    }

    &__wrap, &__bed, &__cots {
      display: flex;
      align-items: center;
    }

    &__bed {
      align-items: flex-start;
      line-height: normal;
      margin-right: 10px;

      &-icon {
        margin-top: 3px;
      }

      &-text {
        font-weight: $vb-font-weight-semibold;
        color: $secondary;
      }
    }

    &__cots {
      margin-top: 3px;
      font-size: $font-size-md;
    }

    &__facilities {
      border-top: 1px solid $gray-200;
      margin-top: 20px;
      padding-top: 20px;
      max-height: 200px;
      overflow: hidden;

      &--open {
        max-height: none;
      }

      &-title {
        font-size: $font-size-lg;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: 15px;
      }

      &-list {
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;

        &_item {
          list-style: none;
          line-height: normal;
          margin: 4px 0;
          width: 100%;
          display: flex;
          align-items: center;
          font-size: $font-size-md;

          @include media-breakpoint-up(md) {
            width: 50%;
          }

          @include media-breakpoint-up(lg) {
            padding: 2px 20px 2px 0;
            margin: 2px 5px 2px 0;
            width: 32%;
          }
        }

        &_icon {
          margin-top: 2px;
          margin-right: 10px;
        }
      }
    }

    &__show {
      display: block;
      text-align: center;
      color: $info;
      text-decoration: underline;
      font-size: $font-size-md;
      cursor: pointer;
      justify-content: flex-end;
      margin-top: 15px;
    }
  }

  ::v-deep {

    .rooms {
      &-info {
        &__name {
          font-size: $font-size-md;
        }
      }
    }
  }

</style>